import { useRef } from 'react';
import { motion, useScroll, useTransform, useReducedMotion } from 'framer-motion';

/*
 * A giant condensed word that slides sideways as you scroll past it
 * (the "STUDIO SHOWCASE" effect). Renders as the section heading.
 */
export default function ScrollWords({ as: Tag = 'h2', id, children, accent }) {
  const ref = useRef(null);
  const reduce = useReducedMotion();
  const { scrollYProgress } = useScroll({ target: ref, offset: ['start end', 'end start'] });
  const x = useTransform(scrollYProgress, [0, 1], reduce ? ['0%', '0%'] : ['18%', '-38%']);

  return (
    <div ref={ref} className="relative overflow-hidden py-4">
      <motion.div style={{ x }} className="whitespace-nowrap will-change-transform">
        <Tag id={id} className="display inline-block whitespace-nowrap text-[22vw] leading-[0.85] text-[#C9DCE4] sm:text-[17vw]">
          {children} {accent && <span className="text-glow text-[#4FB0E7]">{accent}</span>}
        </Tag>
      </motion.div>
    </div>
  );
}
